import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let ConvenienceFeeDetails = class ConvenienceFeeDetails extends Mixins(ViewportSizeMixin) {
    formatString(input) {
        return input
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }
    data() {
        return {
            showOrders: false,
            headers: [
                {
                    text: 'Order No.',
                    align: 'left',
                    sortable: false,
                    value: 'orderNo',
                },
                {
                    text: 'Order Status',
                    align: 'center',
                    sortable: false,
                    value: 'orderStatus',
                },
                {
                    text: 'Convenience Fee',
                    align: 'right',
                    sortable: false,
                    value: 'convenienceFee',
                },
            ],
        };
    }
};
__decorate([
    Prop({ type: String, default: '' })
], ConvenienceFeeDetails.prototype, "billiPeriod", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], ConvenienceFeeDetails.prototype, "ordersBaseOnConvenienceFee", void 0);
ConvenienceFeeDetails = __decorate([
    Component({
        computed: {
            totalConvenienceFee() {
                return this.ordersBaseOnConvenienceFee.length * 10;
            },
        },
    })
], ConvenienceFeeDetails);
export default ConvenienceFeeDetails;
